function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#222428;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Calque_2"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Calque_1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M21,27.7L21,27.7c-0.4,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.5,0.7-0.5,1.1c0,0.9,0.7,1.6,1.6,1.6 c0.4,0,0.9-0.2,1.2-0.5c0.3-0.3,0.5-0.7,0.5-1.1C22.6,28.4,21.9,27.7,21,27.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M38.5,12.6c-1-2.3-2.4-4.4-4.2-6.2c-1.8-1.8-3.9-3.2-6.2-4.2c-2.4-1-5.5-1.5-7.6-1.4s-2.3,0.1-3.8,0.4 c-3.4,0.7-6.9,2.6-9.5,5.3c-3.5,3.6-5.5,8.4-5.5,13.4c0,2.8,0.7,5.7,1.9,8.2L1,35.5l-0.1,0.2v0c-0.3,1.1,0,2.3,0.8,3.2 c0.6,0.6,1.4,1,2.3,1c0.4,0,0.7-0.1,1.1-0.2l7.4-2.5c2.6,1.2,5.4,1.9,8.3,1.9c5,0,9.8-2,13.4-5.5c3.6-3.6,5.7-8.3,5.7-13.3 C40,17.5,39.5,15,38.5,12.6z M6.9,28.6C7,28.1,7,27.7,6.8,27.3C5.6,25,5,22.5,5,19.9c0-8.6,7-15.7,15.6-15.8 C24.9,4,28.9,5.6,32,8.7c3.1,3.1,4.7,7.1,4.6,11.4c-0.1,8.6-7.2,15.6-15.8,15.6c0,0,0,0,0,0c-2.6,0-5.1-0.6-7.4-1.8 c-0.4-0.2-0.9-0.3-1.3-0.1l-7.9,2.7L6.9,28.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.5,16c0.9,0,1.7-0.7,1.7-1.6c0-1.6,1.3-2.8,2.8-2.8c1.6,0,2.8,1.3,2.8,2.8c0,1.6-1.3,2.8-2.8,2.8 c-0.9,0-1.7,0.7-1.7,1.7v4.6c0,0.9,0.7,1.7,1.7,1.7c0.9,0,1.6-0.7,1.6-1.7v-3.2c2.6-0.7,4.5-3.2,4.5-5.9c0-3.4-2.8-6.1-6.1-6.1h0 c-3.4,0-6.1,2.8-6.1,6.1C14.8,15.3,15.6,16,16.5,16z"
})));

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40.7",
    style: {
      enableBackground: "new 0 0 40 40.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.c8749abb.svg";
export { ForwardRef as ReactComponent };